import { render, staticRenderFns } from "./ProposalAgreementsRouterVue.vue?vue&type=template&id=1daa424c&"
import script from "./ProposalAgreementsRouterVue.vue?vue&type=script&lang=js&"
export * from "./ProposalAgreementsRouterVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports